import RequestInstance from '../request.instance';
import { IResponse } from '../request.interface';
import { IQueryMeta } from '../response.interface';
import { ITokenActivityReq, ITokenInfoReq, ITokenOrderReq, ITrendingReq } from './token.request.interface';
import {
  ITrending,
  IHotToken,
  ITokenInfo,
  ITokenActivity,
  IHoldingToken,
  ITokenOrder,
  ITxsTrending,
  IHolder,
  IPumpToken,
  IEvmTokenBalance,
} from './token.response.interface';

class TokenApiService {
  private readonly requestInstance: RequestInstance;
  constructor() {
    this.requestInstance = new RequestInstance();
  }

  // 获取热门代币列表
  async getTokenHotList(): Promise<IResponse<IHotToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/search/trending`,
      method: 'GET',
    });
  }

  // 搜索代币
  async getSearchToken(params: { query: string }): Promise<IResponse<IHotToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/search`,
      method: 'GET',
      params,
    });
  }

  // 获取token趋势列表
  async getTokenTrendList(params: ITrendingReq): Promise<IResponse<{ items: ITrending[]; meta: IQueryMeta }>> {
    return await this.requestInstance.businessRequest({
      url: `/token/trending`,
      method: 'GET',
      params,
    });
  }

  // 获取token详情
  async getTokenInfo(params: ITokenInfoReq): Promise<IResponse<ITokenInfo>> {
    return await this.requestInstance.businessRequest({
      url: `/token/${params.address}`,
      method: 'GET',
    });
  }

  // 获取特定代币的交易记录
  async getTokenActivity(params: ITokenActivityReq): Promise<IResponse<{ items: ITokenActivity[]; meta: IQueryMeta }>> {
    return await this.requestInstance.businessRequest({
      url: `/token/activity`,
      method: 'GET',
      params,
    });
  }

  // 获取代币价格
  async getTokenPriceList(addresses: string[]): Promise<IResponse<IHoldingToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/token/token-basic`,
      method: 'POST',
      data: { addresses },
    });
  }

  // 获取代币的成交记录
  async getTokenOrder(params: ITokenOrderReq): Promise<IResponse<ITokenOrder[]>> {
    return await this.requestInstance.businessRequest({
      url: `/token/my-orders`,
      method: 'GET',
      params,
    });
  }

  async getTxsTrending(params: { tokenAddress: string }): Promise<IResponse<{ txsTrending: ITxsTrending[] }>> {
    return await this.requestInstance.businessRequest({
      url: `/token/txs-trending`,
      method: 'GET',
      params,
    });
  }

  async getTokenHolders(params: { tokenAddress: string }): Promise<IResponse<{ items: IHolder[] }>> {
    return await this.requestInstance.businessRequest({
      url: `/token/holders`,
      method: 'GET',
      params,
    });
  }

  // 获取新创建的pump代币
  async getPumpNewBorn(): Promise<IResponse<IPumpToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/board/newborn`,
      method: 'GET',
    });
  }
  // 获取即将打满的pump代币
  async getPumpLaunching(): Promise<IResponse<IPumpToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/board/launching`,
      method: 'GET',
    });
  }
  // 获取已发射的pump代币
  async getPumpLaunched(): Promise<IResponse<IPumpToken[]>> {
    return await this.requestInstance.businessRequest({
      url: `/board/launched`,
      method: 'GET',
    });
  }

  // 获取用户持有的代币 仅供evm使用
  async getEvmWalletHoldingList(params: { wallet: string }): Promise<IResponse<IEvmTokenBalance[]>> {
    return await this.requestInstance.businessRequest({
      url: `/token/owner-tokens`,
      method: 'GET',
      params,
    });
  }
}

export default new TokenApiService();
